export enum TicketLogParty {
  None = 'NONE',
  SEA = 'SEA',
  Customer = 'CUSTOMER',
  Dealer = 'DEALER',
}

export enum TicketLogChannel {
  None = 'NONE',        // usually system
  Email = 'EMAIL',      // email in/out
  Web = 'WEB',          // web (b2b portal site)
  Log = 'LOG',          // local log
  GCIC = 'GCIC',        // G-CIC site
}
